import { FilterList } from '@mui/icons-material';
import { Badge, IconButton, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import SvgIcon from '@mui/material/SvgIcon';
import { Box, Stack } from '@mui/system';
import moment from 'moment';
import type { FC } from 'react';
import { useCallback, useRef, useState } from 'react';
import { usePopover } from 'src/hooks/use-popover';
import { BasicDateRangeCalendar } from 'src/layouts/components/CustomDatePicker';
import { ArrowIcon, CalenderIcon } from '../dashboard-icon';

interface MultiSelectProps {
  label?: string;
  onChange?: (value: any[]) => void;
  options?: { label: string; value: unknown }[];
  value?: any[];
  setSelectedDueDate: any;
  selectedDueDate: any;
}

export const MenuDateFilter: FC<MultiSelectProps> = (props) => {
  const {
    label,
    onChange,
    options,
    value = [],
    selectedDueDate,
    setSelectedDueDate,
    ...other
  } = props;
  const popover = usePopover<HTMLButtonElement>();

  const calenderRef1 = useRef<HTMLDivElement | null>(null);
  const calenderRef2 = useRef<HTMLDivElement | null>(null);

  const [openCalender1, setOpenCalender1] = useState(false);
  const [selectedDate1, setSelectedDate1] = useState<any>(new Date());

  //date 2
  const [openCalender2, setOpenCalender2] = useState(false);
  const [selectedDate2, setSelectedDate2] = useState<any>(new Date());

  const [isFilterApply, setIsFilterApply] = useState(false);

  const handleFromClickCalender = useCallback(() => {
    setOpenCalender1((prev) => !prev);
    setOpenCalender2(false);
  }, []);

  const handleToClickCalender = useCallback(() => {
    setOpenCalender2((prev) => !prev);
    setOpenCalender1(false);
  }, []);

  const handleChangeFromDateDate = (e: any, source: any) => {
    const originalDate = new Date(e);
    setIsFilterApply(false);
    if (source == 'From') {
      setSelectedDate1(originalDate);
      setOpenCalender1(false);

      return;
    }
    setSelectedDate2(originalDate);
    setOpenCalender2(false);
  };

  const applyDateFilter = () => {
    setIsFilterApply(true);
    setSelectedDueDate({
      startDate: selectedDate1,
      endDate: selectedDate2,
    });
    popover.handleClose();
  };

  const handleCLearAllDoc = () => {
    setIsFilterApply(false);
    setSelectedDate1(new Date());
    setSelectedDate2(new Date());
    setOpenCalender1(false);
    setOpenCalender2(false);
    setSelectedDueDate((prev: any) => ({
      ...prev,
      startDate: '',
      endDate: '',
    }));
  };

  return (
    <>
      <IconButton
        onClick={popover.handleOpen}
        ref={popover.anchorRef}
        {...other}
        sx={{
          padding: '0px',
        }}
      >
        {selectedDueDate?.startDate && selectedDueDate?.endDate ? (
          <Badge
            color="primary"
            variant="dot"
          >
            <FilterList sx={{ color: '#6C737F', padding: '0px' }} />
          </Badge>
        ) : (
          <FilterList sx={{ color: '#6C737F', padding: '0px' }} />
        )}
      </IconButton>

      <Menu
        anchorEl={popover.anchorRef.current}
        onClose={popover.handleClose}
        open={popover.open}
        PaperProps={{ style: { width: 370 } }}
      >
        <Box
          sx={{
            padding: '1rem',
          }}
        >
          <Stack>
            <Typography variant="subtitle2"> {label}</Typography>{' '}
          </Stack>
          <Stack
            flexDirection="column"
            justifyContent={'space-between'}
            alignContent={'center'}
          >
            <Stack
              gap={2}
              flexDirection="row"
              alignItems={'center'}
            >
              <Stack ref={calenderRef1}>
                <Typography
                  sx={{ margin: '10px 0px', color: '#6C737F' }}
                  variant="caption"
                >
                  Start
                </Typography>{' '}
                <Button
                  sx={{
                    padding: '6px 4px',
                    // width: 142px;
                    width: '142px',
                    background: '#fff',
                    borderRadius: '12px',
                    border: '1px solid rgba(17, 25, 39, 0.16)',
                    color: '#384250',
                    '&:hover': {
                      border: '1px solid rgba(17, 25, 39, 0.16)',
                    },
                  }}
                  startIcon={
                    <SvgIcon>
                      <CalenderIcon />
                    </SvgIcon>
                  }
                  variant="outlined"
                  onClick={handleFromClickCalender}
                >
                  {moment(selectedDate1).format('MMM D, YYYY')}
                </Button>
              </Stack>
              <Stack sx={{ marginTop: '38px' }}>
                <ArrowIcon />
              </Stack>

              <Stack ref={calenderRef2}>
                <Typography
                  sx={{ margin: '10px 0px', color: '#6C737F' }}
                  variant="caption"
                >
                  End
                </Typography>{' '}
                <Button
                  sx={{
                    padding: '6px 4px',
                    width: '142px',
                    background: '#fff',
                    borderRadius: '12px',
                    border: '1px solid rgba(17, 25, 39, 0.16)',
                    color: '#384250',
                    '&:hover': {
                      border: '1px solid rgba(17, 25, 39, 0.16)',
                    },
                  }}
                  onClick={handleToClickCalender}
                  startIcon={
                    <SvgIcon>
                      <CalenderIcon />
                    </SvgIcon>
                  }
                  variant="outlined"
                >
                  {moment(selectedDate2).format('MMM D, YYYY')}
                </Button>
              </Stack>
            </Stack>
            <Stack>
              {openCalender1 ? (
                <BasicDateRangeCalendar
                  value={selectedDate1}
                  handleChangeDate={(e: any) => handleChangeFromDateDate(e, 'From')}
                  // futureDisable={true}
                  source={'DueDate'}
                  maxDate={selectedDate2}
                />
              ) : null}

              {openCalender2 ? (
                <BasicDateRangeCalendar
                  value={selectedDate2}
                  handleChangeDate={(e: any) => handleChangeFromDateDate(e, 'To')}
                  // futureDisable={true}
                  source={'DueDate'}
                  minDate={selectedDate1}
                />
              ) : null}
            </Stack>
          </Stack>
          <Stack
            mt={5}
            flexDirection={'row'}
            justifyContent={'flex-end'}
          >
            <Button
              onClick={handleCLearAllDoc}
              variant="outlined"
              size="small"
            >
              Clear
            </Button>
            <Button
              onClick={applyDateFilter}
              disabled={isFilterApply}
              sx={{ marginLeft: '10px' }}
              variant="contained"
              size="small"
            >
              Apply
            </Button>
          </Stack>
        </Box>
      </Menu>
    </>
  );
};
